import Send from '../../send';
import {CheckIn, CheckOut} from "../../../model/in-out";

const DEFAULT_API = '/v1/visit-info/in-out';
export default {

    getVisitorInOutInfo(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    visitorInOutCheckIn(checkInDTO : CheckIn) {
        console.log(checkInDTO);
        return Send({
            url : `${DEFAULT_API}/check-in`,
            method : 'POST',
            data : checkInDTO
        });
    },
    visitorInOutCheckOut(checkOutDTO : CheckOut) {
        return Send({
            url : `${DEFAULT_API}/check-out`,
            method : 'POST',
            data : checkOutDTO
        });
    },

    reVisit(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/re-visit`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    reMind(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/re-mind`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    }
}